/**
 * Builds a browser-loadable URL for user avatar_url from API.
 * Handles absolute URLs, site-root paths (/api/v1/...), and relative storage paths (VITE_FILES_BASE_URL).
 */
export function resolveAvatarUrl(url) {
  const u = String(url ?? '').trim();
  if (!u) return '';
  if (u.startsWith('blob:') || u.startsWith('http://') || u.startsWith('https://')) {
    return u;
  }

  const filesBase =
    (typeof import.meta !== 'undefined' && import.meta.env?.VITE_FILES_BASE_URL) ||
    (typeof process !== 'undefined' && process.env?.VUE_APP_FILES_BASE_URL) ||
    '';

  if (u.startsWith('/')) {
    const origin = typeof window !== 'undefined' ? window.location.origin : '';
    return origin ? `${origin.replace(/\/$/, '')}${u}` : u;
  }

  const path = u.replace(/^\/+/, '');
  if (filesBase) {
    return `${String(filesBase).replace(/\/$/, '')}/${path}`;
  }

  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  return origin ? `${origin.replace(/\/$/, '')}/${path}` : u;
}
